import React from 'react';
import { PropTypes } from 'prop-types';
import Breadcrumbs from '../../../componentsV2/Breadcrumbs/Breadcrumbs';
import { DialogsProvider, ToastProvider } from '../../../providers';
import { withContextProvider } from '../../../hoc';
import AccountForm from './AccountForm';

const DEFAULT_INITIAL_DATA = {
  firstName: '',
  lastName: '',
  email: '',
};

const AccountFormWrapper = ({
  initialData = DEFAULT_INITIAL_DATA,
}) => {
  const breadcrumbLinks = [
    { href: '/admin', name: 'Admin' },
    { href: '/account', name: 'Account' },
  ];

  return (
    <DialogsProvider>
      <div className="mx-2.75">
        <header>
          <Breadcrumbs links={breadcrumbLinks} />
        </header>
        <AccountForm initialData={initialData} />
      </div>
    </DialogsProvider>
  );
};

AccountFormWrapper.propTypes = {
  initialData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
};

export default withContextProvider(ToastProvider)(AccountFormWrapper);

